export default "__VITE_ASSET__UE1BcgYK__"